import React from 'react';
import Tooltip from '../../../../components/common/Tooltip';
import {canReApply} from '../../../../utils/ValidationUtils';
import {generateRoutePath} from 'epic-common/src/route';
import {useCountdown} from '../../../../hooks';
import {Button, Message, Icon, getMessage, svgs} from 'epic-diesel-common';

//@ts-ignore
import styles from './ReapplyButton.pcss';
import {Affiliate} from '../../../../../shared/types';

export interface ReapplyButtonProps {
    affiliateAccount: Affiliate;
    messages: Record<string, string>;
    onClick: () => void;
}

const ReapplyButton: React.FC<ReapplyButtonProps> = ({
    messages,
    affiliateAccount,
    onClick = () => {}
}) => {
    const {earliestReapplicationDate} = affiliateAccount || {};
    const countdown = useCountdown(
        messages,
        earliestReapplicationDate,
        canReApply(affiliateAccount)
    );

    return (
        <>
            <Button
                className={styles.action}
                theme="dark"
                onClick={countdown.expired ? onClick : null}
                to={countdown.expired ? generateRoutePath('signup') : null}
                disabled={!countdown.expired}>
                {countdown.expired ? (
                    <Message code={'epic.affiliate.overview.apply.button'} />
                ) : (
                    <span
                        dangerouslySetInnerHTML={{
                            __html: getMessage(
                                messages,
                                'epic.affiliate.overview.cooldown.button.v2',
                                [countdown.timestamp ? `— ${countdown.timestamp}` : '']
                            )
                        }}
                    />
                )}
            </Button>

            {!countdown.expired && (
                <Tooltip
                    className={styles.tip}
                    placement="right"
                    title={
                        <span
                            dangerouslySetInnerHTML={{
                                __html: getMessage(
                                    messages,
                                    'epic.affiliate.overview.cooldown.tip.v2'
                                )
                            }}
                        />
                    }>
                    <Icon icon={svgs.INFO} />
                </Tooltip>
            )}
        </>
    );
};

export default ReapplyButton;
